import { motion } from "framer-motion";
import CtaButton from "./CtaButton";

const packages = [
  {
    image: "/gallery/love_otherwise-99.jpg",
    title: "The Curated Pop-Up",
    description: "Let us take care of the details for a micro wedding that doesn't feel \"micro\". A personalized, high-end feel for you and up to 20 guests. Available on select dates only.",
    price: "Starting at $6,500",
  },
  {
    image: "/gallery/love_otherwise-117.jpg",
    title: "The Micro Wedding",
    description: "A fully styled, luxe wedding set up for you and up to 30 guests. Our most customizable package.",
    price: "Starting at $9,500",
  },
];

const Packages = () => {
  return (
    <section id="packages" className="bg-background py-20 md:py-28 px-6">
      <div className="mx-auto max-w-7xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <span className="text-xs tracking-[0.3em] uppercase text-warm-gray font-body">Packages</span>
          <h2 className="mt-4 text-3xl md:text-4xl font-display font-light text-foreground">
            Thoughtfully Curated
          </h2>
          <div className="mx-auto mt-6 h-px w-16 bg-champagne" />
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-14">
          {packages.map((pkg, i) => (
            <motion.div
              key={pkg.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: i * 0.15 }}
              className="group"
            >
              <div className="overflow-hidden">
                <img
                  src={pkg.image}
                  alt={pkg.title}
                  width={1440}
                  height={960}
                  loading="lazy"
                  decoding="async"
                  className="w-full h-[400px] md:h-[480px] object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <div className="mt-6">
                <h3 className="text-2xl font-display font-light text-foreground">{pkg.title}</h3>
                <p className="mt-3 text-sm font-body font-light leading-relaxed text-muted-foreground">
                  {pkg.description}
                </p>
                <p className="mt-4 text-xl font-serif italic text-warm-gray">{pkg.price}</p>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="mt-16 flex justify-center"
        >
          <CtaButton href="/packages" variant="outline">
            Explore Packages
          </CtaButton>
        </motion.div>
      </div>
    </section>
  );
};

export default Packages;
